import { predOrBool } from "../../_utils";
import { ConditionProps } from "./_types";
import React from "react";

// Condition component definition
export const Condition = <TProps,>({
  predicate,
  children,
  success,
  unsuccess,
  data,
}: ConditionProps<TProps>) => <>{success}</>;

// Define static properties for success and failure cases
Condition.Success = ({ children }: any) => <>{children}</>;
Condition.Failure = ({ children }: any) => <>{children}</>;
